import * as React from 'react';

import MyItemsUpcomingItemCard from '@/components/GridItemCard/Card/CardOptions/MyItemsItemCards/MyItemsUpcomingItemCard';
import TimedPlusMyItemsCard from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/TimedPlusMyItemsCard';
import { ItemCardComponent, ItemCardInfo } from '@/components/GridItemCard/types/types';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryIsTimedPlusAuction } from '@/redux/modules/item/summary/itemSummary.selectors';

const TimedOrMyItemsItemCard: ItemCardComponent = (props) => {
    const isTimedPlus = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, props.itemId));

    const Component = isTimedPlus ? TimedPlusMyItemsCard.ItemCardComponent : MyItemsUpcomingItemCard.ItemCardComponent;

    return <Component {...props} />;
};

const info: ItemCardInfo = { ItemCardComponent: TimedOrMyItemsItemCard };

export default info;
